export const baseUrl = process.env.REACT_APP_BASE_URL;
export const baseImageUrl =
  process.env.REACT_APP_IMAGE_URL ?? "https://localhost:5001";
export const appUrl =
  process.env.REACT_APP_URL ?? "https://dev.rentificial.com";
export const clientAppUrl =
  process.env.REACT_CLIENT_APP_URL ?? "https://appv2.rentificial.com";
